export { AuthPasswordResetLayout } from './AuthPasswordResetLayout';
